<script setup lang="ts">
  import { post } from '~/services/donationScreen';
  import AsteriskText from '../Forms/AsteriskText.vue';
  import type { ResponseStatus } from '~/types';

  const props = defineProps<{
    visible: boolean;
    close: () => void;
    vendorId: string;
  }>();

  const modalState = reactive<{
    // password: string;
    rejection_note: string;
  }>({
    // password: '',
    rejection_note: ''
  });

  const loading = ref<ResponseStatus>('idle');
  const router = useRouter();
  const route = useRoute();

  const updateModalRef = ref();
  const updateModalRules = {
    rejection_note: [{ required: true, message: 'Reason for denial is required!', trigger: 'submit' }]
    // password: [{ required: true, message: 'Password is required!', trigger: 'submit' }]
  };

  const identifier = route.query.identifier;

  const handleModalOk = async () => {
    loading.value = 'pending';
    try {
      const isValid = await updateModalRef.value.validate();
      if (isValid) {
        const response: any = await post('/v1/reject_vendor', {
          data: {
            uid: props.vendorId,
            rejection_note: modalState.rejection_note
            // edit_password: modalState.password
          }
        });
        if (response.data.status === 'success') {
          loading.value = 'success';
          props.close();
          router.push('/payees').then(() => {
            router.push(`/payees?drawerFrom=payees&identifier=${identifier}`);
          });
          openSuccessfulCustomNotification(response?.data?.message);
        } else {
          loading.value = 'error';
          openFailedCustomNotification(response?.data?.message);
        }
      }
    } catch (error: any) {
      loading.value = 'error';
      if (error?.data?.message) {
        openFailedCustomNotification(error.data.message);
      }
      console.error(error);
    } finally {
      if (loading.value === 'pending') loading.value = 'idle';
    }
  };
</script>

<template>
  <a-modal
    :visible="props.visible"
    title=" Deny Payee"
    class="account-info-modal"
    ok-text="Deactivate"
    @ok="handleModalOk"
    @cancel="props.close"
  >
    <a-form
      ref="updateModalRef"
      layout="vertical"
      label-align="left"
      class="flex flex-col gap-3"
      :label-col="{ style: { width: '183px' } }"
      :colon="false"
      :rules="updateModalRules"
      :model="modalState"
      :hide-required-mark="true"
    >
      <p class="sm-medium text-gray-600">Are you sure you want to reject this vendor?</p>
      <div class="flex flex-col w-full gap-3">
        <a-form-item name="rejection_note" class="!sm-medium">
          <div class="flex flex-col gap-2">
            <AsteriskText label="Reason for denial" />
            <a-textarea v-model:value="modalState.rejection_note" class="w-[547px]" :rows="3" />
          </div>
        </a-form-item>
        <!-- <a-form-item name="password" class="!sm-medium">
          <div class="flex flex-col gap-2">
            <AsteriskText label="Edit Password" />
            <a-input v-model:value="modalState.password" type="password" class="w-[248px]" />
          </div>
        </a-form-item> -->
      </div>
    </a-form>
    <template #footer>
      <div class="flex gap-1 w-full justify-end border-t border-gray-300 p-3 bg-gray-50 rounded-b-lg">
        <a-button
          :disabled="loading === 'pending'"
          class="rounded text-sm font-medium border border-gray-300 text-gray-500 px-3 py-1.5"
          @click="props.close"
          >Cancel</a-button
        >
        <a-button
          :disabled="loading === 'pending'"
          class="px-3 border !border-red-600 bg-red-600 rounded hover:!bg-red-600 hover:!bg-opacity-70 py-1.5 flex items-center justify-center text-sm font-medium"
          type="primary"
          @click="handleModalOk"
          >Deny</a-button
        >
      </div>
    </template>
  </a-modal>
</template>

<style scoped>
  @import '~/assets/css/modal.css';

  .ant-form-item {
    margin-bottom: 0px !important;
  }
</style>
